export const tradingContest = {
  cyjyds: "貿易競争に参加する",
  jsjxmh: "サプライズブラインドボックスのロックを解除して、豪華な賞品を獲得しましょう",
  hdsj: "活動時間",
  mrjxsj: "毎日 00:00 から 23:59 UTC+8 まで実施されます。",
  ckxxgz: "細則",
  wdjj: "私のボーナス",
  jlkj: "カウントダウン",
  cjjc: "スーパー賞金プール",
  jjmrzj: "ボーナスは毎日増加します",
  kqxjd: "新しいステージを開いて報酬を増やしましょう",
  dyjd: "最初の段階",
  dejd: "第二段階",
  dsjd: "第三段階",
  dsijd: "ステージ4",
  jrmhjj: "本日のブラインドボックス特典",
  syjj: "残りのボーナス",
  yblqje: "受取金​​額",
  tjmh: "特製ブラインドボックス",
  yjmh: "1段ボックス",
  ejmh: "2段ボックス",
  sjmh: "3段ボックス",
  jj: "ボーナス: ",
  gs: "個",
  djdkrymh: "クリックするとサプライズブラインドボックスが開きます",
  kydk: "今日開けてもいいよ",
  jxmh: "惊喜ブラインド盒",
  dkmhxyxx: "ブラインドボックスを開けるには {amount}個の星が必要です。",
  xzyyxx: "スターが {amount} 個になりました",
  xxqlsj: "スタークリア時間：{date} （スタークリア前にブラインドボックスを回収してください）",
  wdxx: "私のスター",
  xxhq: "スター獲得",
  hqxxtj: "スターの入手方法",
  yxhysxf: "永久契約: 手数料 {amount}U ごとに 1 つ星を獲得",
  qqhysxf: "オプション契約: 取引量 {amount}U ごとに 1 つ星を獲得",
  youxihysxf: "GameFi: トランザクション量 {amount}U ごとに 1 つ星を獲得",
  gxhd: "おめでとうございます",
  jlydrzh: "報酬はあなたの「{account}」に入金されました",
  qzjzhck: "Gamefiアカウントに移動して表示します",
  bwcjjc: "Bikingスーパー賞金プール",
  qmxjyds: "オールスタートレーディングコンペティション",
  gbgbyb: "試してみませんか？",
  bwcjjcdnn: "バイキング スーパー賞金プール、ブラインド ボックス賞金の {amount}% が毎日あなたにプレゼントされます!",
  cjjcqmxjys: "コインキングスーパー賞金プール オールスター トレーディング コンペティションの賞金プールの {amount}% が毎日ブラインド ボックスに追加されます。",
  syyxbd: "開けるだけで少額で勝ち取れます。",
  zgtk: "頂上に到達したいですか？来て戦ってください！",
  zhyz: "毎日の賞金プールの {amount}% が最終決戦まで蓄積されます。",
  dfdj: "誰がBiking競技の最高賞を獲得できるでしょうか?",
  gsjj: "BiKingスーパー賞金プール オールスター トレーディング コンペティションの達人たちが、",
  qmxpk: "オールスター PK の本当の結果を見るために集まります。",
  jymh: "トレード、ブラインドボックス、ランキングなど、バイクアリーナを楽しみましょう！",
  zzbzy: "永久契約、オプション、GameFi、スポット取引など、周囲のゲームプレイは層ごとにアップグレードされ、毎週同じになることはありません。",
  jlfh: "バイキング スーパー賞金プール オールスター トレーディング コンペティションでは、名声と富を獲得してヒーローになるために、寛大な報酬があなたを待っています!",
  mh: "ブラインドボックス",
  cb: "トップへ急げ",
  jy: "トランザクション",
  syxxs: "残りの星の数",
  xxbhs: "星の数が変わります",
  sjlx: "イベントの種類",
  jycp: "トレーディング商品",
  jye: "取引量",
  myxgjl: "まだ関連する報酬を受け取っていません",
  jyhd: "取得したトランザクション",
  ql: "クリア",
  kqmh: "ブラインドボックスを開ける",
  yx: "GameFi ゲーム",
  bchdyjs: "このイベントは終了しました",
  gffjj: "このコンテストでは合計賞品が配布されます",
  kqmhsl: "ブラインドボックス数量を有効にする",
  cjjcjj: "スーパージャックポットボーナス",
  cjjchjmd: "スーパー賞金プールの勝者リスト",
  jjdyyh: "ボーナスはユーザーの資金口座に入金されました",
  hdjj: "ボーナスを得る",
  wff: "未発行",
  mhhjjl: "ブラインドボックス",
  cjdjhjjl: "スーパー賞",
  jjse: "ボーナス額",
  xhxxs: "消費したスターの数",
  bwqmxgz: "Biking オールスタートレーディング競技規則",
  hdnr: "活動内容",
  hdnrgz: "バイキング スーパー賞金プール オールスター トレーディング コンペティションは、永久契約、オプション契約、GameFi ゲーム、スポット取引という 4 つの主要分野をカバーしています。イベントは 4 週間に分かれており、毎週新しい取引商品が徐々にアンロックされ、多次元取引チャレンジで「スター」を獲得し、豪華な報酬を獲得することができます。毎日の賞金プールの {total}% がブラインド ボックスの抽選に使用され、サプライズ報酬がすぐに入手可能です。残りの{amount}％は大会終了まで貯められ、取引ランキングに応じて最高報酬が山分けされます！",
  hdjd: "活動段階",
  jbjs: "徐々にロックが解除され、4 サイクルの競争アップグレードが行われます",
  dyzq: "最初のサイクル",
  kqyxhy: "永久契約取引を有効にすると、取引量が増えるほど、より多くのスター ポイントが得られ、賞金プールの報酬も高くなります。",
  dezq: "2番目のサイクル",
  jmqqjy: "オプション取引の取引を増やし、損益双方向のジャックポットを獲得して、スターの数を再びアップグレードできるようになります。",
  dszq: "3番目のサイクル",
  cjgejc: "GameFi ゲームに参加し、さまざまな取引体験を通じてスターを獲得し、高額の賞金を獲得しましょう。",
  dsizq: "4番目のサイクル",
  gfzzdj: "ブラインド ボックスの賞金プールは最初の 3 週間は引き続きオープンされ、スポット取引リストは最終賞金を共有するために個別に設定されます。",
  jzszjs: "賞金総額の計算",
  jxmhgz1: "毎日セルの{amount}％がブラインドに割り当てられ、100個のブラインドが即座に、4等のクラスの商品が瞬間的に評価されます。奖励自动蓄積积到次日奖池，让收益持续增长！特级盒、一级盒等每日刷新、超高中奖率等您来开！",
  mhfpmx: "毎日のブラインド数は {total} で、セルの {amount}% を占めます。",
  tjmhzb: "賞金総額の{amount}%を占める特別なブラインドボックス{total}つ",
  yjmhzb: "{total}つの第1レベルのブラインドボックス、賞金総額の{amount}%を占める",
  ejmhzb: "{total}の二次ブラインドボックス、賞金プールの{amount}%を占める",
  sjmhzb: "{total}の第3レベルのブラインドボックスは、賞金プールの{amount}％を占めます。",
  kmhxxyq: "开盲盒必要な星星数要求：每日盲盒奖池金额/{text}",
  tips: "注意: すべてのブラインドボックスは、毎日 0 ポイントを更新し、前日に生成された各商品交換ボックスを経由して、ボックス池 + 前日ボックスの残りのお金を再計算し、以上の等価階級を当日のブラインドボックスに割り当てます。",
  mrjyyk: "賞金総額は、永久契約、オプション契約、GameFi の 3 つの主要セクターにおける日々の取引損益に基づいています。",
  mgyld: "各利益注文の {amount}% = 利益額 * {amount}%",
  mrjcljdjs: "毎日の賞金プールの {amount}% がイベント終了まで蓄積され、4 つの主要取引商品のランキングの上位 3 つに分配されます。継続賞金プールの割合は次のとおりです。永久契約の場合は 40%、オプションが 30%、GameFi が 20%、スポット製品が 10% です。",
  yhhyyld: "例: ユーザーの契約注文利益が 1000U の場合、1000*{amount}%={total}U がその日の賞金プールに入ります。",
  mgksd: "各損失注文の {amount}% = 実際の損失額 (損失 - 清算) * {amount}%",
  yhhyks: "たとえば、ユーザーの契約注文が実際に 1000U を失った場合、1000*{amount}%={total}U がその日の賞金プールに入ります。",
  qqhyyld: "各利益注文の {amount}% = 賭け金 * オッズ * {amount}%",
  qqyhddtz: "たとえば、ユーザーがオプション注文に 100U を賭けて 10 秒以内に利益を得た場合、100*65%*{amount}%={total}U がその日の賞金プールに入ります。",
  qqhyksd: "各損失注文の {amount}% = 損失額 * {amount}%",
  yhksjrjc: "たとえば、ユーザーのオプション注文の損失が 100U の場合、100*{amount}%={total}U がその日の賞金プールに入ります。",
  yxyld: "各利益注文の {amount}% = 賭け金 * オッズ * {amount}%",
  yxddtz: "例: ユーザーゲームFIオーダーは、オッズが 2 倍であると仮定して、100U をベットします。利益が出た場合、100*200%*{amount}%={total}U がその日の賞金プールに入ります。",
  yxmgksd: "各損失注文の {amount}% = 損失額 * {amount}%",
  yhqqksd: "たとえば、ユーザーのオプション注文の損失が 100U の場合、100*{amount}%={total}U がその日の賞金プールに入ります。",
  daiding: "未定",
  yytz: "活動調整",
  kaiqi: "開く",
  xhjyjrpm: "スポット取引がランキングに加わる",
  drjy: "同じ日に取引して翌​​日受け取る",

}


// WEBPACK FOOTER //
// ./src/i18n/lang/tradingContest/ja_JP.js